export default "__VITE_ASSET__CDX0VNJZ__"